/**
 * @typedef {Object} TabItem
 * @property {number} [id]
 * @property {string} [label]
 * @property {number} [errors]
 * @property {boolean} [disabled]
 * @property {string} [tooltip]
 */

/**
 * @typedef {Object} Impairment
 * @property {number} [id]
 * @property {string} [nome]
 * // TODO preencher isso com retorno do backend
 */

export const TabEnum = Object.freeze({
  SUMARIO_CONTABIL: 1,
  PERIODOS_ANTERIORES: 2,
  FONTES_EXTERNAS: 3,
  FONTES_INTERNAS: 4,
  RELATORIO_INTERNO: 5,
  POSICAO_FINAL: 6,
  MEMORIA_EVIDENCIAS: 7
});
